import { VEB_ELIGIBLITY_MESSAGE } from "../../../constants/eligiblityMessage";
import { Member } from "../../../types/employee.types";
import { VEBPlanName } from "../../../types/plan.types";
import calculateAge from "../age";

//minium age is 18
export const getType1Eligiblity = (age: number): boolean => {
	if (age < 18) {
		return false;
	} else {
		return true;
	}
};

export const getSTDEligiblity = (age: number): boolean => {
	if (age < 18 || age > 64) {
		return false;
	} else {
		return true;
	}
};

//Min age 18 max age 70
export const getType2Eligiblity = (age: number): boolean => {
	if (age < 18 || age > 70) {
		return false;
	} else {
		return true;
	}
};

export const getVEBEmployeeEligiblity = (
	VEBPlanName: string,
	employee: Member
): { isEligible: boolean; eligiblityMessage: string } => {
	const age = calculateAge(employee.date_of_birth, "03-01-2025");
	switch (VEBPlanName) {
		case "Cancer": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Accident": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Critical Illness": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Hospital Indemnity": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Short Term Disability": {
			return { isEligible: getSTDEligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Whole life": {
			return { isEligible: getType2Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Family Protection": {
			return { isEligible: getType2Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Doc and Rx": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Group Life Indemnity": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Vision": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		case "Dental": {
			return { isEligible: getType1Eligiblity(age), eligiblityMessage: VEB_ELIGIBLITY_MESSAGE[VEBPlanName] };
		}
		default:
			throw "Invalid VEB Plan name";
	}
};
